<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Marketplace Ürünleri</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field v-model="search" append-icon="search" label="Ara" single-line hide-details></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="selectOnSale"
        :items="onSaleItems"
        item-value="id"
        item-text="value" 
        @change="applyFilters"
        hide-details
        label="Satışta/Pasif"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <!-- Kategori Seçimi -->
      <v-combobox
        v-model="selectCategory"
        :items="categoryItems"
        item-value="id"
        @change="applyFilters"
        item-text="value"
        hide-details
        label="Kategori"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <!-- Site Kategori Seçimi - Sadece MpId = 5 için -->
      <template v-if="isMp5">
        <v-select
          v-model="selectSiteCategory"
          :items="siteCategoryItems"
          item-value="key"
          item-text="name"
          hide-details
          label="Site Kategori"
          clearable
        ></v-select>
        <v-divider class="mx-2" inset vertical></v-divider>
      </template>
      <v-btn color="primary" dark @click="applyFilters" class="mb-2">Ara</v-btn>
      <v-btn color="success" dark @click="showMissingProducts" class="mb-2">Eksik Ürünler</v-btn>
      <v-btn 
        v-if="showSyncButton" 
        color="warning" 
        dark 
        @click="syncFromMain" 
        class="mb-2" 
        :loading="syncLoading"
      >
        Ana Tablodan Senkronize Et
      </v-btn>
    </v-toolbar>
    
    <!-- Ana Ürün Listesi -->
    <v-data-table
      :headers="headers"
      :loading="this.$store.state.progress"
      :rows-per-page-items="pageItems"
      :items="filteredItems"
      :pagination.sync="pagination"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-0 text-xs-center"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td class="px-0 text-xs-center">{{ props.item.id }}</td>
        <td class="px-0 text-xs-center">{{ props.item.product.id  }}</td>
        <td class="px-0 text-xs-center">{{ props.item.mpSku !=null ? props.item.mpSku : "N/A" }}</td>
        <td class="px-0 text-xs-center" v-if="props.item.product">{{ props.item.product.name }}</td>
        <td class="px-0 text-xs-center" v-else>-</td>
        <td class="px-0 text-xs-center" v-if="props.item.product">{{ props.item.product.sku }}</td>
        <td class="px-0 text-xs-center" v-else>-</td>
        <!-- Ana Kategori Kolonu -->
        <td class="px-0 text-xs-center">{{ getCategoryName(props.item.product ? props.item.product.productCategoryId : null) }}</td>
        <!-- Site Kategori Kolonu - Sadece MpId = 5 için -->
        <td v-if="isMp5" class="px-0 text-xs-center">{{ getSiteCategoryText(props.item) }}</td>
        
        <td class="px-0 text-xs-center">{{ props.item.price.toFixed(2) }}</td>
        <td class="px-0 text-xs-center">{{ props.item.listPrice.toFixed(2) }}</td>
        <td class="px-0 text-xs-center">{{ props.item.purchasePrice.toFixed(2) }}</td>
        <td class="px-0 text-xs-center">{{ props.item.stock }}</td>
        <td class="px-0 text-xs-center">{{ props.item.formula || '-' }}</td>
        <!-- Fiyat Artışı Kolonu -->
        <td class="px-0 text-xs-center">{{ props.item.priceIncreaseAmount ? props.item.priceIncreaseAmount.toFixed(2) + ' TL' : '-' }}</td>
        <td class="px-0 text-xs-center" v-if="props.item.onSale">Satışta</td>
        <td class="px-0 text-xs-center" v-else>Pasif</td>
        <td class="px-0 text-xs-center">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>

    <!-- Eksik Ürünler Dialog - Modern Tasarım -->
    <v-dialog v-model="missingProductsDialog" max-width="1024px" persistent scrollable>
      <v-card class="missing-products-dialog">
        <!-- ÜST ALAN - Header -->
        <div class="missing-dialog-header">
          <div class="header-left">
            <div class="header-title-row">
              <h1 class="header-title">Ana Tabloda Olup MP'de Olmayan Ürünler</h1>
              <span class="product-count-badge">
                {{ filteredMissingProducts.length }} / {{ totalMissingProducts }} ürün
              </span>
            </div>
          </div>
          <button 
            class="add-selected-btn"
            :class="{ 'btn-disabled': selectedMissingProducts.length === 0 }"
            @click="syncSelectedProducts" 
            :disabled="selectedMissingProducts.length === 0 || syncLoading"
          >
            <v-icon class="btn-icon">add</v-icon>
            SEÇİLENLERİ EKLE ({{ selectedMissingProducts.length }})
          </button>
        </div>
        
        <!-- Arama Alanı -->
        <div class="missing-search-area">
          <div class="search-input-wrapper">
            <v-icon class="search-icon">search</v-icon>
            <input 
              v-model="missingProductSearch"
              type="text"
              class="search-input"
              placeholder="Ürün Ara (ID, SKU, İsim)"
            />
            <v-icon 
              v-if="missingProductSearch" 
              class="clear-icon" 
              @click="missingProductSearch = ''"
            >close</v-icon>
          </div>
        </div>

        <!-- ORTA ALAN - Scrollable Tablo -->
        <div class="missing-dialog-content">
          <table class="modern-table">
            <thead>
              <tr>
                <th class="th-select">
                  <div class="th-content">
                    Seç <v-icon small>arrow_upward</v-icon>
                  </div>
                </th>
                <th>Id</th>
                <th>SKU</th>
                <th>Ürün Adı</th>
                <th class="text-right">Fiyat</th>
                <th class="text-right">Stok</th>
                <th>Durum</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="item in filteredMissingProducts" 
                :key="item.id"
                class="table-row"
                :class="{ 'row-selected': isItemSelected(item) }"
              >
                <td class="td-checkbox">
                  <input 
                    type="checkbox" 
                    class="modern-checkbox"
                    :checked="isItemSelected(item)"
                    @change="toggleItemSelection(item)"
                  />
                </td>
                <td class="td-id">{{ item.id }}</td>
                <td>{{ item.sku }}</td>
                <td>{{ item.name }}</td>
                <td class="text-right">{{ item.price.toFixed(2) }}</td>
                <td class="text-right">{{ item.availableStock }}</td>
                <td>{{ item.state ? 'Aktif' : 'Pasif' }}</td>
              </tr>
              <tr v-if="filteredMissingProducts.length === 0">
                <td colspan="7" class="no-data-cell">
                  <div class="no-data-content">
                    <v-icon large color="grey">search_off</v-icon>
                    <p>Arama kriterine uygun ürün bulunamadı.</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- ALT ALAN - Footer -->
        <div class="missing-dialog-footer">
          <div class="footer-left">
            <button 
              class="footer-btn primary-btn"
              @click="selectAllFiltered"
              :disabled="filteredMissingProducts.length === 0"
            >
              <v-icon class="btn-icon">select_all</v-icon>
              TÜMÜNÜ SEÇ
            </button>
            <button 
              class="footer-btn secondary-btn"
              @click="clearSelection"
              :disabled="selectedMissingProducts.length === 0"
            >
              <v-icon class="btn-icon">deselect</v-icon>
              SEÇİMİ TEMİZLE
            </button>
          </div>
          <button class="footer-btn primary-btn" @click="closeMissingDialog">
            <v-icon class="btn-icon">close</v-icon>
            KAPAT
          </button>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    pagination: {
      sortBy: "mpSku"
    },
    selectOnSale: { id: -1, value: "Tümü" },
    selectCategory: { id: 0, value: "Tümü" },
    selectSiteCategory: null,
    search: null,
    syncLoading: false,
    missingProductsDialog: false,
    selectedMissingProducts: [],
    missingProductSearch: '',
 
    showSyncButton: false,
    keySequence: '',
    secretCode: 'mahmutaltunkaya',
    lastKeyTime: Date.now(),
    pageItems: [
      500,
      1000,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],
    onSaleItems: [
      { id: -1, value: "Tümü" },
      { id: false, value: "Pasif" },
      { id: true, value: "Satışta" }
    ],
    // Kategori seçenekleri - ID'ler productCategoryId ile eşleşiyor
    categoryItems: [
      { id: -1, value: "Tümü" },
      { id: 1, value: "çeyrek altın" },
      { id: 2, value: "yarım altın" },
      { id: 3, value: "tam altın" },
      { id: 4, value: "ata lira" },
      { id: 5, value: "24 ayar gram altın" },
      { id: 6, value: "22 ayar gram altın" },
      { id: 7, value: "Gremse ve Arma" },
      { id: 8, value: "Bilezik grubu" }
    ],
    // Kategori ID'den isim eşleştirmesi için map
    categoryMap: {
      1: "çeyrek altın",
      2: "yarım altın", 
      3: "tam altın",
      4: "ata lira",
      5: "24 ayar gram altın",
      6: "22 ayar gram altın",
      7: "Gremse ve Arma",
      8: "Bilezik grubu"
    },
    // Base headers - Site Kategori computed'da eklenecek
    baseHeaders: [
      {
        text: "Id",
        align: "left",
        value: "id"
      }, 
      { text: "Ürün Id", value: "product.id" },
      { text: "MP SKU", value: "mpSku" },
      { text: "Ürün Adı", value: "product.name" },
      { text: "Ana SKU", value: "product.sku" },
      { text: "Ana Kategori", value: "product.productCategoryId" },
      { text: "Fiyat", value: "price" },
      { text: "Liste Fiyatı", value: "listPrice" },
      { text: "Alış Fiyatı", value: "purchasePrice" },
      { text: "Stok", value: "stock" },
      { text: "Formül", value: "formula" },
      { text: "Fiyat Artışı", value: "priceIncreaseAmount" },
      { text: "Durum", value: "onSale" },
      { text: "İşlem", value: "id", sortable: false }
    ],
    missingProductHeaders: [
      {text: "Seç", value: "data-table-select"},
      { text: "Id", value: "id" },
      { text: "SKU", value: "sku" },
      { text: "Ürün Adı", value: "name" },
      { text: "Fiyat", value: "price" },
      { text: "Stok", value: "availableStock" },
      { text: "Durum", value: "state" }
    ]
  }),

  computed: {
    // MpId = 5 kontrolü
    isMp5() {
      const selectedMpId = localStorage.getItem('selectedMpId');
      return selectedMpId === '5';
    },
    
    // Site Kategori seçenekleri (ağaç yapısında)
    siteCategoryItems() {
      const items = [{ key: null, name: "Tümü" }];
      
      // Kategorisiz seçeneği
      items.push({ key: "UNCATEGORIZED", name: "Kategorisiz" });
      
      // Store'dan gelen kategorileri al
      const categories = this.$store.state.categories.all || [];
      
      // Kategorileri levelDepth ve sortOrder'a göre sırala
      const sortedCategories = [...categories].sort((a, b) => {
        if (a.levelDepth !== b.levelDepth) return a.levelDepth - b.levelDepth;
        return a.sortOrder - b.sortOrder;
      });
      
      // Ağaç yapısında göstermek için recursive fonksiyon
      const buildTreeItems = (parentKey = null, prefix = "") => {
        const children = sortedCategories.filter(c => {
          const catParentKey = c.parentKey || c.ParentKey;
          if (parentKey === null) {
            return !catParentKey || catParentKey === "";
          }
          return catParentKey === parentKey;
        });
        
        children.forEach(category => {
          const catKey = category.categoryKey || category.CategoryKey;
          const catName = category.name || category.Name || catKey;
          if (catKey && catKey !== "UNCATEGORIZED") {
            items.push({
              key: catKey,
              name: prefix + catName,
              levelDepth: category.levelDepth || 0
            });
            // Alt kategorileri ekle
            buildTreeItems(catKey, prefix + "— ");
          }
        });
      };
      
      buildTreeItems(null, "");
      
      return items;
    },
    
    // Seçilen kategorinin tüm alt kategori key'lerini döndür
    getDescendantCategoryKeys() {
      if (!this.selectSiteCategory || this.selectSiteCategory === "UNCATEGORIZED") {
        return [];
      }
      
      const categories = this.$store.state.categories.all || [];
      const descendants = [this.selectSiteCategory];
      
      const findDescendants = (parentKey) => {
        categories.forEach(cat => {
          const catParentKey = cat.parentKey || cat.ParentKey;
          const catKey = cat.categoryKey || cat.CategoryKey;
          if (catParentKey === parentKey && catKey) {
            descendants.push(catKey);
            findDescendants(catKey);
          }
        });
      };
      
      findDescendants(this.selectSiteCategory);
      return descendants;
    },
    
    // Headers - MpId = 5 ise Site Kategori kolonu eklenir
    headers() {
      const headers = [...this.baseHeaders];
      
      if (this.isMp5) {
        // Ana Kategori'den sonra Site Kategori ekle (index 6)
        headers.splice(6, 0, { text: "Site Kategori", value: "product.categoryKey" });
      }
      
      return headers;
    },
    
    filteredItems() {
      let items = this.$store.state.mpProducts.all || [];
      
      // OnSale filtresi
      if (this.selectOnSale.id !== -1) {
        items = items.filter(item => item.onSale === this.selectOnSale.id);
      }
      
      // Kategori filtresi - productCategoryId ile karşılaştır
      if (this.selectCategory.id > 0) {
        items = items.filter(item => {
          if (!item.product || !item.product.productCategoryId) return false;
          return item.product.productCategoryId === this.selectCategory.id;
        });
      }
      
      // Site Kategori filtresi (sadece MpId = 5 ise)
      if (this.isMp5 && this.selectSiteCategory) {
        if (this.selectSiteCategory === "UNCATEGORIZED") {
          items = items.filter(item => {
            const categoryKey = item.product ? (item.product.categoryKey || item.product.CategoryKey) : null;
            return !categoryKey || categoryKey === "UNCATEGORIZED";
          });
        } else {
          // Seçilen kategori ve tüm alt kategorilerini al
          const validKeys = this.getDescendantCategoryKeys;
          items = items.filter(item => {
            if (!item.product) return false;
            const productCatKey = item.product.categoryKey || item.product.CategoryKey;
            return validKeys.includes(productCatKey);
          });
        }
      }
      
      return items;
    },
    
    // Eksik ürünler için toplam sayı
    totalMissingProducts() {
      return (this.$store.state.mpProducts.missingProducts || []).length;
    },
    
    // Eksik ürünler için filtrelenmiş liste
    filteredMissingProducts() {
      const items = this.$store.state.mpProducts.missingProducts || [];
      
      if (!this.missingProductSearch || this.missingProductSearch.trim() === '') {
        return items;
      }
      
      const searchTerm = this.missingProductSearch.toLowerCase().trim();
      
      return items.filter(item => {
        const id = item.id ? item.id.toString() : '';
        const sku = item.sku ? item.sku.toLowerCase() : '';
        const name = item.name ? item.name.toLowerCase() : '';
        
        return id.includes(searchTerm) || 
               sku.includes(searchTerm) || 
               name.includes(searchTerm);
      });
    }
  },

  created() {
   
  },

  async mounted() {
    window.addEventListener('keypress', this.handleKeyPress);
    
    // Kategorileri yükle (Site Kategori için)
    await this.$store.dispatch("getAllCategories");
    
    this.initialize();
  },

  beforeDestroy() {
    window.removeEventListener('keypress', this.handleKeyPress);
  },

  methods: {
    // Kategori ID'sinden kategori ismini döndüren metod
    getCategoryName(categoryId) {
      if (!categoryId) return '-';
      return this.categoryMap[categoryId] || '-';
    },
    
    // Site Kategori için text döndüren metod
    getSiteCategoryText(item) {
      if (!item || !item.product) return '-';
      const categoryKey = item.product.categoryKey || item.product.CategoryKey;
      if (!categoryKey || categoryKey === "UNCATEGORIZED") {
        return "Kategorisiz";
      }
      // Store'dan kategori adını bul
      const categories = this.$store.state.categories.all || [];
      const category = categories.find(c => 
        (c.categoryKey || c.CategoryKey) === categoryKey
      );
      return category ? (category.name || category.Name) : categoryKey;
    },
    
    async initialize() {
      await this.$store.dispatch("mpProducts/searchMpProduct", {
        search: this.search,
        onSale: null // Tüm veriyi çek, filtreleme frontend'de yapılacak
      });
    },
    
    applyFilters() {
      // Filtreleme computed property'de otomatik yapılıyor
      // Bu metod sadece manuel arama butonu için
    },
    
    editItem(item) {
      window.open("/mpproduct/detail/" + item.id, '_blank');
    },

    deleteItem(item) {
      if (confirm("Silmek İstediğinizden Emin Misiniz?")) {
        this.$store.dispatch("mpProducts/deleteMpProduct", item);
      }
    },
    
    async showMissingProducts() {
      await this.$store.dispatch("mpProducts/getMissingProducts");
      this.missingProductsDialog = true;
      this.selectedMissingProducts = [];
      this.missingProductSearch = '';
    },
    
    closeMissingDialog() {
      this.missingProductsDialog = false;
      this.missingProductSearch = '';
      this.selectedMissingProducts = [];
    },
    
    selectAllFiltered() {
      this.selectedMissingProducts = [...this.filteredMissingProducts];
    },
    
    clearSelection() {
      this.selectedMissingProducts = [];
    },
    
    isItemSelected(item) {
      return this.selectedMissingProducts.some(p => p.id === item.id);
    },
    
    toggleItemSelection(item) {
      const index = this.selectedMissingProducts.findIndex(p => p.id === item.id);
      if (index > -1) {
        this.selectedMissingProducts.splice(index, 1);
      } else {
        this.selectedMissingProducts.push(item);
      }
    },
    
    async syncFromMain() {
      this.syncLoading = true;
      try {
        await this.$store.dispatch("mpProducts/syncFromMainProducts");
        this.$store.commit('SET_MESSAGE', 'Ana tablodan senkronizasyon başarılı!');
        await this.initialize();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Sync error:', error);
        this.$store.commit('SET_MESSAGE', 'Senkronizasyon sırasında hata oluştu!');
      } finally {
        this.syncLoading = false;
      }
    },
    
    async syncSelectedProducts() {
      if (this.selectedMissingProducts.length === 0) {
        alert('Lütfen en az bir ürün seçin!');
        return;
      }
      
      this.syncLoading = true;
      try {
        const productIds = this.selectedMissingProducts.map(p => p.id);
        await this.$store.dispatch("mpProducts/syncFromMainProducts", productIds);
        this.missingProductsDialog = false;
        this.$store.commit('SET_MESSAGE', 'Seçilen ürünler başarıyla eklendi!');
        await this.initialize();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Sync selected error:', error);
        this.$store.commit('SET_MESSAGE', 'Ürün ekleme sırasında hata oluştu!');
      } finally {
        this.syncLoading = false;
      }
    },
    
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    handleKeyPress(event) {
      const currentTime = Date.now();
      
      if (currentTime - this.lastKeyTime > 2000) {
        this.keySequence = '';
      }
      
      this.lastKeyTime = currentTime;
      this.keySequence += event.key;
      
      if (this.keySequence === this.secretCode) {
        this.showSyncButton = true;
        this.keySequence = '';
        // eslint-disable-next-line no-console
        console.log('🔓 Sync butonu aktif edildi!');
      }
      
      if (this.keySequence.length > this.secretCode.length) {
        this.keySequence = this.keySequence.slice(-this.secretCode.length);
      }
    }
  }
};
</script>

<style scoped>
/* Modal Ana Yapı */
.missing-products-dialog {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  border-radius: 8px;
  overflow: hidden;
}

/* Header */
.missing-dialog-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #ffffff;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-title-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.header-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.product-count-badge {
  background-color: rgba(14, 165, 233, 0.1);
  color: #0ea5e9;
  padding: 4px 12px;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 9999px;
}

.add-selected-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #0ea5e9;
  color: white;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-selected-btn:hover:not(:disabled) {
  background-color: #0278af;
}

.add-selected-btn.btn-disabled,
.add-selected-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-icon {
  font-size: 20px !important;
}

/* Arama Alanı */
.missing-search-area {
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #ffffff;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #9ca3af;
  pointer-events: none;
}

.search-input {
  width: 100%;
  padding: 8px 40px 8px 40px;
  background-color: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #111827;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.search-input:focus {
  border-color: #0ea5e9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
}

.search-input::placeholder {
  color: #6b7280;
}

.clear-icon {
  position: absolute;
  right: 12px;
  color: #9ca3af;
  cursor: pointer;
  font-size: 18px !important;
}

.clear-icon:hover {
  color: #6b7280;
}

/* Tablo İçerik Alanı */
.missing-dialog-content {
  flex: 1;
  overflow-y: auto;
  min-height: 200px;
  max-height: 50vh;
}

/* Modern Tablo */
.modern-table {
  width: 100%;
  font-size: 0.875rem;
  text-align: left;
  color: #4b5563;
  border-collapse: collapse;
}

.modern-table thead {
  font-size: 0.75rem;
  color: #374151;
  text-transform: uppercase;
  background-color: #f9fafb;
  position: sticky;
  top: 0;
  z-index: 1;
}

.modern-table thead th {
  padding: 12px 24px;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
}

.modern-table thead th.th-select {
  width: 80px;
}

.modern-table thead th .th-content {
  display: flex;
  align-items: center;
  gap: 4px;
}

.modern-table tbody tr {
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.15s;
}

.modern-table tbody tr:hover {
  background-color: #f9fafb;
}

.modern-table tbody tr.row-selected {
  background-color: rgba(14, 165, 233, 0.05);
}

.modern-table tbody td {
  padding: 16px 24px;
}

.modern-table tbody td.td-checkbox {
  padding: 16px 24px;
}

.modern-table tbody td.td-id {
  font-weight: 500;
  color: #111827;
}

.modern-table .text-right {
  text-align: right;
}

/* Modern Checkbox */
.modern-checkbox {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  background-color: #f3f4f6;
  cursor: pointer;
  accent-color: #0ea5e9;
}

.modern-checkbox:checked {
  background-color: #0ea5e9;
  border-color: #0ea5e9;
}

.modern-checkbox:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.2);
}

/* Veri Yok */
.no-data-cell {
  padding: 40px 24px !important;
  text-align: center;
}

.no-data-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
}

.no-data-content p {
  margin: 0;
}

/* Footer */
.missing-dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 24px;
}

.footer-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  padding: 8px 4px;
  border: none;
  background: none;
  cursor: pointer;
  transition: color 0.2s;
}

.footer-btn.primary-btn {
  color: #0ea5e9;
}

.footer-btn.primary-btn:hover:not(:disabled) {
  color: #0284c7;
}

.footer-btn.secondary-btn {
  color: #6b7280;
}

.footer-btn.secondary-btn:hover:not(:disabled) {
  color: #374151;
}

.footer-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.footer-btn .btn-icon {
  font-size: 20px !important;
}
</style>